import { useEffect, useState } from "react";
import { db } from "../firebase.js";
import { ref, get } from "firebase/database";

const CustomerReviews = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    if (!db) return;
    get(ref(db, "orders")).then((snap) => {
      if (!snap.exists()) return;
      const all = Object.values(snap.val());
      const rated = all
        .filter((o) => o.rating && o.status === "delivered")
        .sort((a, b) => (b.ratedAt || 0) - (a.ratedAt || 0))
        .slice(0, 20);
      setReviews(rated);
    }).catch(() => {});
  }, []);

  if (reviews.length === 0) return null;

  const avg = (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(1);

  return (
    <section className="py-3" style={{ background: "#fff8f0" }}>
      <div className="container-fluid px-3">
        {/* Header */}
        <div className="d-flex align-items-center gap-3 mb-2 px-1">
          <span className="fw-bold" style={{ fontSize: 13 }}>Customer Reviews</span>
          <div className="d-flex align-items-center gap-1">
            <span className="fw-bold" style={{ fontSize: 12 }}>{avg}</span>
            {[1,2,3,4,5].map((s) => (
              <i key={s} className={`bi bi-star${s <= Math.round(avg) ? "-fill" : ""} text-warning`} style={{ fontSize: 10 }} />
            ))}
            <span className="text-muted" style={{ fontSize: 11 }}>({reviews.length})</span>
          </div>
        </div>

        {/* Horizontal scroll strip */}
        <div
          className="d-flex gap-2"
          style={{ overflowX: "auto", scrollbarWidth: "none", paddingBottom: 4 }}
        >
          {reviews.map((r, i) => (
            <div
              key={i}
              style={{
                minWidth: 210,
                maxWidth: 210,
                background: "#fff",
                borderRadius: 10,
                padding: "10px 12px",
                boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                flexShrink: 0,
              }}
            >
              <div className="d-flex align-items-center gap-1 mb-1">
                <img
                  src={r.photoURL || `https://api.dicebear.com/7.x/fun-emoji/svg?seed=${r.email?.split("@")[0] || i}`}
                  alt="avatar"
                  style={{ width: 28, height: 28, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }}
                  onError={(e) => { e.target.src = `https://api.dicebear.com/7.x/fun-emoji/svg?seed=${i}`; }}
                />
                <span className="fw-semibold text-truncate" style={{ fontSize: 12, maxWidth: 100 }}>
                  {r.name || r.email?.split("@")[0] || "Customer"}
                </span>
                <span className="ms-auto text-success" style={{ fontSize: 9 }}>
                  <i className="bi bi-patch-check-fill" style={{ fontSize: 11 }} />
                </span>
              </div>

              <div className="d-flex gap-1 mb-1">
                {[1,2,3,4,5].map((s) => (
                  <i key={s} className={`bi bi-star${s <= r.rating ? "-fill" : ""} text-warning`} style={{ fontSize: 11 }} />
                ))}
              </div>

              <p className="mb-0 text-muted" style={{ fontSize: 11, lineHeight: 1.4,
                display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                "{r.review || "Great product! Highly recommended."}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CustomerReviews;
